import { RootStateTypes } from './types';
import { MutationTree } from 'vuex';

// 同步执行
const mutations: MutationTree<RootStateTypes> = {
    SET_ROUTE_NAME(state: RootStateTypes, data: string) {
        state.routeName = data;
    },
    SET_ACCOUNT_DIALOG_TYPE(state: RootStateTypes, data: string) {
        state.accountDialogType = data;
    },
    SET_SHOW_ACCOUNT_DIALOG(state: RootStateTypes, data: boolean) {
      console.log('showAccountDialog', data);
        state.showAccountDialog = data; 
    },
    SET_USER_INFO(state: RootStateTypes, data: any) {
        state.userInfo = data;
    }
};
export default mutations;
